import { Card, Col, Row, Table } from "antd";
import React from "react";

function PropertiesOwned({data}) {
  // const columns = [
  //   {
  //     dataIndex: "property1",
  //     title: "",
  //     key: "property1",
  //   },
  //   {
  //     dataIndex: "property",
  //     title: "Property",
  //     key: "property",
  //   },
  //   {
  //     dataIndex: "percentOwned",
  //     title: "Percent Owned",
  //     key: "percentOwned",
  //     render: (text) => <span>{text} </span>
  //   },
  // ];


  const property = "Hello World" || "";
  const percentOwned = "100.0%" || "";

  const dataSource = [
    {
      key: 1,
      property,
      percentOwned,
    },
    {
      key: 2,
      property,
      percentOwned,
    },
    {
      key: 3,
      property,
      percentOwned,
    },
  ];

  const columns = [
    {
      title: '',
      dataIndex: '',
      key: '',
      render: () => <a>{" "}</a>,
    },
    {
      title: 'Property',
      dataIndex: 'property',
      key: 'property',
      render: () => <a>{property}</a>,
    },
    {
      title: 'Percent Owned',
      dataIndex: 'percentOwned',
      key: 'percentOwned',
      render: () => <span>{percentOwned}</span>,
    },
    
  ];

  return (
    <Card title="Properties Owned">
      <Row>
        <Col span={24} className="table-container">
          <Table columns={columns} dataSource={dataSource} pagination={false}/>
        </Col>
      </Row>
    </Card>
  );
}

export default PropertiesOwned;


